import MetricPage from './pages/metric';
import NotFoundPage from './pages/not_found';
import ProfilePage from './pages/profile';
import ProfileOrCategoryPage from './pages/profile_or_category';

const routes = [
  {
    path: '/schools/:categorySlug/metrics/:slug',
    component: MetricPage
  },
  {
    path: '/schools/:categorySlug/:slug',
    component: ProfilePage
  },
  {
    path: '/schools/:slug',
    component: ProfileOrCategoryPage
  },
  {
    path: '*',
    component: NotFoundPage
  }
];

export default routes;
